<template>
  <div
    class="car"
    @mouseover="isMouseOver = true"
    @mouseleave="isMouseOver = false"
    @click="$emit('select', car.value)"
  >
    <div class="car__image-wrapper">
      <transition name="fade">
        <img
          :id="id"
          :key="key"
          :src="imgSrc"
          :alt="`Model ${car.label}`"
          class="car__image"
        >
      </transition>
    </div>
    <label
      :for="id"
      class="car__label"
      v-html="car.label"
    />
  </div>
</template>

<script>
  import { get } from 'lodash'

  export default {
    name: 'Car',
    props: {
      car: {
        type: Object,
        required: true,
        validator (car) {
          return 'images' in car &&
            'default' in car.images &&
            'hover' in car.images &&
            'label' in car &&
            'value' in car
        }
      }
    },
    data () {
      return {
        isMouseOver: false
      }
    },
    computed: {
      id () {
        return `car-model-${this.car.value}`
      },
      key () {
        return `car-model-${this.imgSrc}`
      },
      imgSrc () {
        return this.isMouseOver && document.documentElement.classList.contains('has-hover')
          ? get(this, 'car.images.hover')
          : get(this, 'car.images.default')
      }
    },
    activated () {
      this.isMouseOver = false
    }
  }
</script>

<style lang="scss">
  $imgHeight: 80px;
  $imgHeightMobile: 110px;

  .car {
    all: unset;
    position: relative;
    display: block;
    max-width: 290px;
    padding: 0;
    cursor: pointer;
    background: none;
    border: none;
    outline: none;

    &__image {
      &-wrapper {
        height: $imgHeight;

        @include mobile {
          height: $imgHeightMobile;
        }
      }

      position: absolute;
      width: 100%;
      height: $imgHeight;

      @include object-fit();

      @include mobile {
        height: $imgHeightMobile;
      }
    }

    &__label {
      display: block;
      padding-top: 20px;
      font-size: 22px;
      color: $c-black;
      text-align: center;
      cursor: pointer;
      transition: color 0.3s, -webkit-text-fill-color 0.3s;

      @include mobile {
        padding-top: 5px;
        font-size: 18px;
      }
    }

    &:focus {
      .car__label {
        color: $c-active;
        -webkit-text-fill-color: $c-active;
      }
    }

    @include hover {
      .car__label {
        color: $c-active;
        -webkit-text-fill-color: $c-active;
      }
    }
  }
</style>
